<template>
  <div id="content" class="crpg-o-free-food-free-food-content campaign_2">
    <div id="detail" class="crpg-o-free-food-free-food-content__detail">
      <AtomsCommonFreeTopTitle
        :title01="content.topTitle.topTitle01"
        :title02="content.topTitle.topTitle02"
        :title03="content.topTitle.topTitle03"
        :title04="content.topTitle.topTitle04"
      />
      <div class="pic_1">
        <a class="lightbox" @click="zoomEvent">
          <img
            :src="contentTopImage"
            :alt="content.topImageText.topImageAlt"
            class="food"
          />
          <img
            :src="require(`@/assets/img/common/icon_expan.png`)"
            class="icon"
          />
        </a>
        <span class="note newline">
          {{ content.topImageText.topImageContent }}
        </span>
        <span class="shop">
          {{ content.topImageText.topImageArea }}
          <span class="area">{{ content.topImageText.topImageArea2 }}</span>
        </span>
      </div>
      <div class="pic_3">
        <MoleculesFreeFoodFShopGallery
          v-for="item in content.photoGallery"
          :key="item.image"
          :image="item.image"
          :title="item.title"
          :area="item.area"
        />
      </div>
      <div class="coupon">
        <h4>{{ contentImageTitle }}</h4>
        <p>
          <img :src="contentImage" :alt="contentImageAlt" />
        </p>
      </div>
      <div class="note">
        <h4 style="text-indent: 0">{{ $t("freeFood.timeline") }}</h4>
        <p>{{ content.notePeriod }}</p>
      </div>
      <div class="note">
        <MoleculesFreeFoodFInfo :note="content.note" />
      </div>
      <div id="list">
        <div class="title-l">{{ $t("freeFood.stores") }}</div>
        <table>
          <tbody v-for="item in content.shopList" :key="item.shopListName">
            <MoleculesFreeFoodFShopList
              :shopListName="item.shopListName"
              :shopListCategory="item.shopListCategory"
              :shopListArea="item.shopListArea"
              :shopListCourse="item.shopListCourse"
              :shopListPrice="item.shopListPrice"
            />
          </tbody>
        </table>
        <div class="group-box">
          <div class="title-l">{{ $t("freeFood.esquireClub") }}</div>
          <p class="group-txt">{{ content.esquireclub }}</p>
          <h3>{{ $t("freeFood.whatIsEsquireClub") }}</h3>
          <div class="group-txt">
            {{ content.esquireclubContentDetail }}
            <br />
            <br />
            {{ content.esquireclubHomepageTitle }}
            <a href="https://www.esquire-club.co.jp/" alt="" target="_blank">
              {{ $t("freeFood.link") }}
            </a>
            <ul>
              <li
                v-for="item in content.esquireclubContent"
                :key="item.esquireclubContentText"
              >
                {{ item.esquireclubContentText }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <MoleculesFreeFoodFGroupList />
      <div class="attention">
        <p
          class="attention__text"
          v-for="item in content.groupListTextDate"
          :key="item.groupListText"
        >
          {{ item.groupListText }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import AtomsCommonFreeTopTitle from "@/components/atoms/common/FreeTopTitle.vue";
import MoleculesFreeFoodFGroupList from "@/components/molecules/freeFood/GroupList.vue";
import MoleculesFreeFoodFInfo from "@/components/molecules/freeFood/Info.vue";
import MoleculesFreeFoodFShopGallery from "@/components/molecules/freeFood/ShopGallery.vue";
import MoleculesFreeFoodFShopList from "@/components/molecules/freeFood/ShopList.vue";

import text from "@/assets/txt/free_food.json";

var textDate = text;

export default {
  name: "FreeFoodContent",
  components: {
    AtomsCommonFreeTopTitle,
    MoleculesFreeFoodFGroupList,
    MoleculesFreeFoodFInfo,
    MoleculesFreeFoodFShopGallery,
    MoleculesFreeFoodFShopList,
  },
  data() {
    return {
      content: textDate,
      contentTopImage: require("@/assets/img/free_food.jpg"),
      contentTop: "アンティカ・オステリア・デル・ポンテ（東京/丸の内）",
      contentTopAlt: "アンティカ・オステリア・デル・ポンテ",
      contentTopText:
        "1年に1回、下記対象店舗の中からご希望のレストランを選び、1枚につき2名様までご利用いただけます。\n無料お食事ご招待券は、プレステージ・ゴールドへのご入会時、または更新時に1枚お送りします。",
      contentTopArea: "（東京/丸の内）",
      contentImageTitle: "【無料お食事ご招待券見本】",
      contentImageAlt: "無料お食事ご招待券見本",
      contentImage: require("@/assets/img/coupon_1.jpg"),
    };
  },
  methods: {
    zoomEvent() {
      this.$store.dispatch("zoom/show", ["freefood", "pic_1.jpg"]);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/organisms/freeFood/freeFoodContent.scss";
</style>
